import TrendingBusinesses from './TrendingBusinesses.component';

export default TrendingBusinesses;